// EditStudent Component for update student data 

// Import Modules 
import React, { useState, useEffect } from "react";
import { useParams, useNavigate,useOutletContext } from "react-router-dom";
import axios from "axios";
import { useLocation } from "react-router-dom";
import PatientAnyavyadhiForm from "../Forms/PatientAnyavyadhiForm";
import CONFIG from '../../config';
import { usePatient } from "../../context/PatientContext";
import { useAuth } from "../../context/AuthProvider";



// EditStudent Component 
const EditPatientAnyavyadhi = () => {
  const { markSectionComplete } = useOutletContext() ;  
  const navigate = useNavigate();
  const { verifyTokenAndRedirect } = useAuth();
  const location = useLocation();
  const { patientData, setPatientData, selectedCase, selectedVisit, doctorInfo } = usePatient();
  const {patientId, caseId, visitId} = useParams();

  useEffect(() => {

    verifyTokenAndRedirect();

  }, []);


  //onSubmit handler 
  const onSubmitHandler = (updatedPatientAnyavyadhi) => {

    console.log("patient data after submit:", updatedPatientAnyavyadhi); // Log the data to be updated

    // const updatedData = {
    //   ...patientData,
    //   patientAnyavyadhi: [{ ...updatedPatientAnyavyadhi }] // Overwrite patientInfo while keeping other data unchanged
    // };

    // const updatedData = {
    //   ...patientData, 
    //   patientAnyavyadhi: patientData.patientAnyavyadhi.map(info => ({
    //       ...info, // Keep existing patientInfo fields
    //       ...updatedPatientAnyavyadhi // Merge updated fields
    //   }))
    // };

  //   const updatedData = {
  //     ...patientData,
  //     patientAnyavyadhi: patientData.patientAnyavyadhi.length > 0 
  //         ? patientData.patientAnyavyadhi.map(info => ({
  //             ...info, // Keep existing patientInfo fields
  //             ...updatedPatientAnyavyadhi // Merge updated fields
  //         }))
  //         : [updatedPatientAnyavyadhi] // If empty, create a new array with updatedPatientAnyavyadhi
  // };

  const updatedData = {
    ...patientData,
    patientAnyavyadhi: patientData?.patientAnyavyadhi?.length > 0 
        ? patientData.patientAnyavyadhi.map(info => ({
            ...info, // Keep existing patientInfo fields
            ...updatedPatientAnyavyadhi, // Merge updated fields
            PATIENT_ID: patientData.PATIENT_ID, 
            CASE_ID: selectedCase || caseId, // Add CASE_ID if missing
            VISIT_ID: selectedVisit || visitId,  // Add VISIT_ID if missing
            DOCTOR_ID: doctorInfo.MANDALI_ID,
            CLINIC_ID: doctorInfo.CLINIC_ID // Merge updated fields
    
        }))
        : [{
            ...updatedPatientAnyavyadhi,
            PATIENT_ID: patientData.PATIENT_ID, 
            CASE_ID: selectedCase || caseId,  // Default CASE_ID if not provided
           VISIT_ID: selectedVisit || visitId, // Default VISIT_ID if not provided
           DOCTOR_ID: doctorInfo.MANDALI_ID,
           CLINIC_ID: doctorInfo.CLINIC_ID // Merge updated fields
   
        }]
  };

    setPatientData(updatedData);
    markSectionComplete("anyavyadhi");
    
    if (location.pathname.startsWith("/addpatient")) {
      navigate("/addpatient/kulawrutta");
    } else if (location.pathname.startsWith("/visits")) {
      navigate(`/visits/${patientId}/${caseId}/${visitId}/kulawrutta`);
    } else {
      console.warn("Unknown route, no redirection");
    }


  };

  // Return student form 
  return (

    <div>
      {console.log('inside rendering: ', patientData)}
      {patientData && (
        <PatientAnyavyadhiForm
          initialValues={patientData}
          onSubmit={onSubmitHandler}
          enableReinitialize={true}
        >
          Update Patient
        </PatientAnyavyadhiForm>
      )}
    </div>
  );

};

export default EditPatientAnyavyadhi;

